/* Mikes Toolshop – Mega-Menü Desktop */
if (!customElements.get('mts-mega')) {
  class MtsMega extends HTMLElement {
    connectedCallback() {
      this.tops = Array.from(this.querySelectorAll('[data-mts-top]'));
      this.offen = null;
      this.timer = null;
      this.hoverFaehig = window.matchMedia('(hover: hover)').matches;

      this.tops.forEach((btn) => {
        const item = btn.parentElement;
        btn.addEventListener('click', () => {
          if (this.offen === btn) this.schliessen(); else this.oeffnen(btn);
        });
        if (this.hoverFaehig) {
          item.addEventListener('mouseenter', () => this.planen(() => this.oeffnen(btn), this.offen ? 60 : 160));
          item.addEventListener('mouseleave', () => this.planen(() => this.schliessen(), 220));
        }
      });

      this.querySelectorAll('[data-mts-bereich]').forEach((a) => {
        const zeigen = () => this.bereich(a);
        a.addEventListener('mouseenter', zeigen);
        a.addEventListener('focus', zeigen);
      });

      this.onKey = (e) => {
        if (e.key === 'Escape' && this.offen) {
          const btn = this.offen;
          this.schliessen();
          btn.focus();
        }
      };
      this.onDoc = (e) => { if (this.offen && !this.contains(e.target)) this.schliessen(); };
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDoc);
      this.addEventListener('focusout', (e) => {
        if (this.offen && e.relatedTarget && !this.contains(e.relatedTarget)) this.schliessen();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDoc);
    }

    planen(fn, ms) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, ms);
    }

    oeffnen(btn) {
      clearTimeout(this.timer);
      if (this.offen && this.offen !== btn) this.zu(this.offen);
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      const header = this.closest('.header') || document.querySelector('.header');
      if (header) document.documentElement.style.setProperty('--mts-mega-top', header.getBoundingClientRect().bottom + 'px');
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      this.offen = btn;
    }

    zu(btn) {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    schliessen() {
      clearTimeout(this.timer);
      if (!this.offen) return;
      this.zu(this.offen);
      this.offen = null;
    }

    bereich(a) {
      const liste = a.closest('.mts-mega__split');
      if (!liste) return;
      liste.querySelectorAll('[data-mts-bereich]').forEach((x) => {
        const aktiv = x === a;
        x.classList.toggle('is-active', aktiv);
        const sub = document.getElementById(x.dataset.mtsBereich);
        if (sub) sub.hidden = !aktiv;
      });
    }
  }
  customElements.define('mts-mega', MtsMega);
}
